<app-loader></app-loader>
<app-environment></app-environment>
<router-outlet></router-outlet>
<app-notifications [trigger]="notification$"></app-notifications>
